export const Rol = (rol) => {
    switch (rol) {
        case 'prd':return "Productor" 
        case 'sala':return "Sala" 
        case 'esp':return "Espectador" 
        default:
            break;
    }
}